import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Avatar, Button, CssBaseline, TextField, Grid, Typography, CircularProgress, Container, Chip, Box } from '@mui/material';
import { QueuePlayNext, DeleteForever } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import Api from '../../services/api';
import CustomizedSnackbars from '../../components/material-snackbars';
import HeaderMenu from '../../components/header-menu';
import { connect } from 'react-redux';
import { browserHistory } from '../../helpers/history';
import { Link } from 'react-router-dom';
import SimpleSelect from '../../components/select/simple';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import SimpleCheckBox from '../../components/checkbox/check';
import { FormattedMessage,injectIntl } from 'react-intl';
import Title from '../../components/title-name';
import * as Service from '../../services/organizationdepartament.service';
import * as componentActions from '../../redux/actions/organizationdepartaments';
import { PapiroConsole } from '../../utils/papiroConsole';
class OrganizationDepartamentEdit extends Component {

  constructor(props) {
    super(props);
            const { userSession,organizationdepartaments, organizations } = this.props;
   
    this.fromProps = false
    if(this.props && this.props.location && this.props.location.state && this.props.location.state.from && this.props.location.state.from.length > 0)
      this.fromProps = true

    this.globalAdm = false;
    this.isClient = true;
    if(userSession.user.userrole == null){
      Api.logoff();
    }

    if(!organizationdepartaments || (organizationdepartaments && !organizationdepartaments.organizationdepartament)) {
      var l = this.props.match.params.lang;
      document.location.href=`/${l}/calleds`
    }

    userSession.user.userrole.map((item, key) => {
            if(item.role.roletype !=3){
                this.isClient = false;
            }
            if(item.role.roletype ==0){
              this.globalAdm =true;
            }
        }
    );

    var parentResult = [];
    // console.log(organizationdepartaments.organizationdepartament);
    /*organizationdepartaments.organizationdepartament.parentorganizationdepartament.map(item => {

      if(item.id != this.state.organizationdepartament.id){
        var parent = {id: item.id, name: item.parentname ? item.parentname : item.name};
        parentResult.push(parent);
      }
      
    });*/
 
    this.initialState = {
      UpdatedUser: userSession.user.id,
      id: organizationdepartaments.organizationdepartament.id,
      OrganizationId:  organizationdepartaments.organizationdepartament.OrganizationId,
      OrganizationText: organizationdepartaments.organizationdepartament.OrganizationText,
      ParentOrganizationDepartamentId: organizationdepartaments.organizationdepartament.parentorganizationdepartament,
      ParentOrganizationDepartamentText: organizationdepartaments.organizationdepartament.ParentOrganizationDepartamentText,
      name : organizationdepartaments.organizationdepartament.name == null ? '' : organizationdepartaments.organizationdepartament.name ,
      parentname : organizationdepartaments.organizationdepartament.parentname == null ? '' : organizationdepartaments.organizationdepartament.parentname ,
      emails: this.parseEmails(organizationdepartaments.organizationdepartament.emails),
      saveToAllOrganizationsInGroup: false,
    };
    // console.log("Aqui");
    // console.log(userSession.user.id);
    this.state = {
      organizationdepartament: this.initialState,
      organizations: organizations,
      files: [],
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      OrganizationList: [],
      ParentOrganizationDepartamentList: [],
      currentEmail: '',

    };
    // console.log(this.state.organizationdepartament.ParentOrganizationDepartamentId);
    
    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.changeValues = this.changeValues.bind(this);
  }

  parseEmails(emails) {
    if (!emails) return [];
    if (Array.isArray(emails)) {
      const flatEmails = [];
      emails.forEach(email => {
        if (typeof email === 'string') {
          if (email.includes(',')) {
            email.split(',').forEach(e => {
              const trimmed = e.trim();
              if (trimmed) flatEmails.push(trimmed);
            });
          } else {
            const trimmed = email.trim();
            if (trimmed) flatEmails.push(trimmed);
          }
        }
      });
      return flatEmails;
    }
    if (typeof emails === 'string') {
      const cleaned = emails.replace(/[{}]/g, '');
      if (cleaned.trim() === '') return [];
      return cleaned.split(',').map(email => email.trim()).filter(email => email.length > 0);
    }
    return [];
  }

  componentDidMount() {
    const intl = this.props.intl;
    if (this.state.organizations && this.state.organizations.organization && this.state.organizations.organization.id) {
      this.getOrganizationsById(this.state.organizations.organization.id);
    }
    else {
      this.getOrganizations();
    }
    this.getParentOrganizationDepartaments(this.state.organizationdepartament.OrganizationId);
  };
     async getOrganizations(){
          this.setState({ loading: true });
          var result = await Service.getOrganizations();
            if (result.success) {
              this.setState({ loading: false, OrganizationList: result.data });
                            
            } else {
              this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.response && result.response.data && result.response.data.errors &&  result.response.data.errors[0] ? result.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
              });
              Api.kickoff(result);  
            }
  };
  
  getOrganizationsById = async (id) => {
    const intl = this.props.intl;
    this.setState({ loading: true });
    var result = await Service.getOrganizationsByIdLight(id);
    if (result.success) {
        this.setState({ loading: false, OrganizationList: [result.data] });

    } else {
        this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.response && result.response.data && result.response.data.errors && result.response.data.errors[0] ? result.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
        });
        Api.kickoff(result);
    }
}

  async getParentOrganizationDepartaments(orgid){
    const intl = this.props.intl;
          this.setState({ loading: true });
          var result = await Service.getParentOrganizationDepartaments(orgid);

            if (result.success) {
              var parentResult = [];
              result.data.map(item => {

                if(item.id != this.state.organizationdepartament.id){
                  var parent = {id: item.id, name: item.parentname ? item.parentname : item.name};
                  parentResult.push(parent);
                }
                
              })
              
              // console.log(parentResult);
              this.setState({ loading: false, ParentOrganizationDepartamentList: parentResult });
                            
            } else {
              this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.response && result.response.data && result.response.data.errors &&  result.response.data.errors[0] ? result.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
              });
              Api.kickoff(result);  
            }
  };

  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    this.setState(prevState => ({
      organizationdepartament: {
        ...prevState.organizationdepartament,
        [name]: value
      }
    }));
  };

  handleSubmit = async e => {
    e.preventDefault();

    this.setState({ loading: true });

    let data = new FormData();


      if (this.isClient) {
        this.setState(prevState => ({
          organizationdepartament: {
            ...prevState.organizationdepartament,
          }
        }));
      } else {
        this.setState(prevState => ({
          organizationdepartament: {
            ...prevState.organizationdepartament,
          }
        }));
      }

      // console.log(this.state.organizationdepartament);

      for (let key in this.state.organizationdepartament) {

        if (key.toString().toLowerCase().indexOf('_date') > -1 || key.toString().toLowerCase().indexOf('date_') > -1) {
          data.append(key, moment(this.state.organizationdepartament[key]).format('YYYY/MM/DD HH:mm:ss'));
        }else if (key.toString().toLowerCase().indexOf('parentorganizationdepartamentid') > -1 && this.state.organizationdepartament[key] != "") {
          data.append(key, this.state.organizationdepartament[key] && this.state.organizationdepartament[key].id ? this.state.organizationdepartament[key].id : 0);
        } else if (key === 'emails') {
          const validEmails = this.state.organizationdepartament[key].filter(email => email && email.trim().length > 0);
          validEmails.forEach(email => data.append('emails', email.trim()));
        } else {
          data.append(key, this.state.organizationdepartament[key]);
        }
      }

      this.state.files.forEach(file => data.append('filesUpload', file));
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
        Api.put('/organizationdepartaments', data, config)

        .then(result => {
          const intl = this.props.intl;
          if (result.data.success) {
            const intl = this.props.intl;
        const formattedList = result.data.data;
        formattedList.OrganizationId=  formattedList.organization ? formattedList.organization.id : 0;
        formattedList.OrganizationText=  formattedList.organization ? formattedList.organization.name : '';
        formattedList.ParentOrganizationDepartamentId=  formattedList.parentorganizationdepartament ? formattedList.parentorganizationdepartament.id : 0;
        formattedList.ParentOrganizationDepartamentText=  formattedList.parentorganizationdepartament ? formattedList.parentorganizationdepartament.name : '';

            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'success',
              notificationMessage: intl.formatMessage({id:"edit.success"}),
              files: []
            });
        if(this.props.organizations && this.state.organizations.organization) {
          this.props.addCurrentOrganization(formattedList, this.state.organizations.organization);
        } else
          this.props.addCurrent(formattedList);
        this.componentDidMount();
 
          }
          else{
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage:  result.data.errors && result.data.errors[0] ? result.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
            });

          }
        })
        .catch(err => {
          const intl = this.props.intl;
          if(err.response && err.response.data && err.response.data.errors){
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
            });
          }
          else{
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})+err.response.data
            });
          }
        });
  };

  closeNotification() {
    this.setState({ openNotification: false });
  }

  changeValues(stateName, value, text = '') {
    this.setState({ loading: true });

    this.setState(prevState => ({
      organizationdepartament: {
        ...prevState.organizationdepartament,
        [stateName]: value
      }
    }));
        if(stateName === 'OrganizationId'){
          this.setState(prevState => ({
            organizationdepartament: {
              ...prevState.organizationdepartament,
              ['OrganizationText']: text,
            }
          }));
          this.getParentOrganizationDepartaments(value);
        }
        if(stateName === 'ParentOrganizationDepartamentId'){
          this.setState(prevState => ({
            organizationdepartament: {
              ...prevState.organizationdepartament,
              ['ParentOrganizationDepartamentText']: text,
            }
          }));
        }
 
    this.setState({ loading: false });

  };

  removeItem(file) {
    let array = [...this.state.files];
    let index = array.indexOf(file)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ files: array });
    }
  }

  handleAddEmail = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      const email = this.state.currentEmail.trim();

      if (email && this.isValidEmail(email)) {
        if (!this.state.organizationdepartament.emails.includes(email)) {
          this.setState(prevState => ({
            organizationdepartament: {
              ...prevState.organizationdepartament,
              emails: [...prevState.organizationdepartament.emails, email]
            },
            currentEmail: ''
          }));
        } else {
          this.setState({
            openNotification: true,
            notificationVariant: 'warning',
            notificationMessage: 'Este email já foi adicionado'
          });
        }
      } else if (email) {
        this.setState({
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: 'Email inválido'
        });
      }
    }
  };

  handleDeleteEmail = (emailToDelete) => {
    this.setState(prevState => ({
      organizationdepartament: {
        ...prevState.organizationdepartament,
        emails: prevState.organizationdepartament.emails.filter(email => email !== emailToDelete)
      }
    }));
  };

  isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) && email.length <= 255;
  };

  handleEmailInputChange = (event) => {
    this.setState({ currentEmail: event.target.value });
  };

    render() {
    const { classes, headerMenu, actionsHeaderMenu, organizationdepartaments } = this.props;
    const { organizationdepartament } = this.state;
    const intl = this.props.intl;

    if(Api == null) {
      var l = this.props.match.params.lang;
      document.location.href=`/${l}/unavailable`
    }

     return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container component='main' maxWidth='md'>
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                    <Button variant='outlined' color='primary'  onClick={() => {
                      this.fromProps ? this.props.history.push(`/${this.props.match.params.lang}/organization-edit`, { organizations: this.props.organizations, propTab: 8 }) : browserHistory.goBack()}
                    }>{this.props.intl.formatMessage({id:"back"})}</Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar className={classes.avatar}>
                <QueuePlayNext />
              </Avatar>
              <Typography component='h1' variant='h5'>
              {<FormattedMessage id="edit.item" />} 
                <Title />
              </Typography>
              <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
                    <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <SimpleSelect label={intl.formatMessage({id:"organization"})} name='organizationid'  options={this.state.OrganizationList} stateName='OrganizationId' changeSelect={this.changeValues} selected={organizationdepartament.OrganizationId} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <SimpleAutoComplete label={intl.formatMessage({id:"organization.departament.parent"})} name='parentorganizationdepartamentid'  options={this.state.ParentOrganizationDepartamentList} stateName='ParentOrganizationDepartamentId' changeSelect={this.changeValues} selected={organizationdepartament.ParentOrganizationDepartamentId} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField inputProps={{ maxLength: 255 }} fullWidth label={intl.formatMessage({id:"name"})} autoComplete='fname' variant='outlined' name='name' onChange={this.handleInputChange} value={organizationdepartament.name} required />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        fullWidth
                        label="Emails (pressione Enter para adicionar)"
                        variant='outlined'
                        value={this.state.currentEmail}
                        onChange={this.handleEmailInputChange}
                        onKeyDown={this.handleAddEmail}
                        helperText="Digite um email e pressione Enter para adicionar. Máximo 255 caracteres por email."
                      />
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
                        {organizationdepartament.emails && organizationdepartament.emails.map((email, index) => (
                          <Chip
                            key={index}
                            label={email}
                            onDelete={() => this.handleDeleteEmail(email)}
                            color="primary"
                            variant="outlined"
                          />
                        ))}
                      </Box>
                    </Grid>
                                    <Grid item xs={11} sm={11}>
                                        <SimpleCheckBox
                                        label={intl.formatMessage({id:"apply.changes.to.all.organizations.in.group"})}
                                        name='saveToAllOrganizationsInGroup'
                                        stateName='saveToAllOrganizationsInGroup' 
                                        changeSelect={this.changeValues}
                                        selected={organizationdepartament.saveToAllOrganizationsInGroup} />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                      <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                  <Grid item xs={12} sm={4}    >
                    <Button 
                      type='submit'
                      fullWidth
                      variant='contained'
                      color='primary'
                      className={classes.submit}
                    >
                      {<FormattedMessage id="save" />}
                    </Button>
                  </Grid>
                  </Grid>
                  </Grid>
                </Grid>
              </form>
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
      </div>
    );
  }
}

OrganizationDepartamentEdit.propTypes = {
  classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
    organizations: state.organizations,
    organizationdepartaments: state.organizationdepartaments
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps,mapDispatchToProps)(withStyles(Styles)(OrganizationDepartamentEdit)));
